// Supported Languages
export const SUPPORTED_LANGUAGES = {
    'en': 'English',
    'es': 'Spanish',
    'fr': 'French',
    'de': 'German',
    'it': 'Italian',
    'pt': 'Portuguese',
    'ru': 'Russian',
    'zh': 'Chinese',
    'ja': 'Japanese',
    'ko': 'Korean'
};
export const DEFAULT_AUDIO_CONFIG = {
    sampleRate: 16000,
    channels: 1,
    bitDepth: 16,
    bufferSize: 4096
};
// Error Codes
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["INVALID_ROOM_ID"] = "INVALID_ROOM_ID";
    ErrorCode["ROOM_NOT_FOUND"] = "ROOM_NOT_FOUND";
    ErrorCode["SPEAKER_ALREADY_EXISTS"] = "SPEAKER_ALREADY_EXISTS";
    ErrorCode["MICROPHONE_ACCESS_DENIED"] = "MICROPHONE_ACCESS_DENIED";
    ErrorCode["AUDIO_PROCESSING_ERROR"] = "AUDIO_PROCESSING_ERROR";
    ErrorCode["TRANSCRIPTION_ERROR"] = "TRANSCRIPTION_ERROR";
    ErrorCode["TRANSLATION_ERROR"] = "TRANSLATION_ERROR";
    ErrorCode["CONNECTION_ERROR"] = "CONNECTION_ERROR";
    ErrorCode["INVALID_MESSAGE_FORMAT"] = "INVALID_MESSAGE_FORMAT";
    ErrorCode["RATE_LIMIT_EXCEEDED"] = "RATE_LIMIT_EXCEEDED";
})(ErrorCode || (ErrorCode = {}));
// Room validation
export const ROOM_ID_REGEX = /^[a-zA-Z0-9-_]{6,32}$/;
export function isValidRoomId(roomId) {
    return ROOM_ID_REGEX.test(roomId);
}
export function generateRoomId() {
    return Math.random().toString(36).substring(2, 15);
}
